"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HARDCOVER_SKUS_ALL_LIST = exports.HARDCOVER_SKUS_EXCLUDING_PHOTO_WRAPPED_LIST = exports.PHOTO_WRAPPED_HARDCOVER_SKUS_LIST = exports.SHIFTED_RIGHT_REGEX = exports.SHIFTED_RIGHT_APPENDIX = exports.PINTURA_VERSION = void 0;
exports.PINTURA_VERSION = '8.74.0';
exports.SHIFTED_RIGHT_APPENDIX = '--SHIFTED_RIGHT';
exports.SHIFTED_RIGHT_REGEX = /--SHIFTED(_RIGHT)?/;
exports.PHOTO_WRAPPED_HARDCOVER_SKUS_LIST = ['photo-wrapped-hardcover', 'wedding-photo-wrapped-hardcover'];
exports.HARDCOVER_SKUS_EXCLUDING_PHOTO_WRAPPED_LIST = ['hardcover', 'hardcover-travel-photo-book', 'hardcover-annual-photo-book', 'hardcover-wedding-photo-book', 'hardcover-milestone-photo-book'];
exports.HARDCOVER_SKUS_ALL_LIST = [...exports.PHOTO_WRAPPED_HARDCOVER_SKUS_LIST, ...exports.HARDCOVER_SKUS_EXCLUDING_PHOTO_WRAPPED_LIST];